module.exports = __webpack_public_path__ + "img/video-art-bg.b21b18e4.svg";